import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioImprimirAdmisionService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getEmpresasAdmision(objetoParametros: ParametrosImprimirAdmisionEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'filtros-reportes/empresas-admision',
        [objetoParametros.codigoBaseDatos, {unco_admision: objetoParametros.uncoAdmision}]
      );

      return response;

    } catch (e) {
      console.log(`ServicioImprimirAdmisionesService.getEmpresasAdmision() ${e}`);
    }

    return null;
  }

  async getEntidadEmpresarial(objetoParametros: ParametrosImprimirAdmisionEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'entidad-empresarial/datos-entidad-sp',
        [objetoParametros.codigoBaseDatos, { unco_sede: objetoParametros.uncoSede }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioSolicitudesSuministros.getEntidadEmpresarial() ${e}`);
    }
    return null;
  }

  async getInformacionUsuario(objetoParametros: ParametrosImprimirAdmisionEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'informacion-usuario/datos',
        [objetoParametros.codigoBaseDatos, { unco_login: objetoParametros.uncoLogin }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioSolicitudesSuministros.getInformacionUsuario() ${e}`);
    }
    return null;
  }

  async getInformacionAfiliado(objetoParametros: ParametrosImprimirAdmisionEntity, objetoFiltros: FiltrosImprimirAdmisionEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'admisiones/informacion-afiliado',
        [objetoParametros.codigoBaseDatos, { unco_admision: objetoParametros.uncoAdmision,
          unco_admision_empresa: objetoFiltros.uncoAdmisionEmpresa }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioImprimirAdmisionService.getInformacionAfiliado() ${e}`);
    }
    return null;
  }

  // Duplicado el método anterior, se cambia el parámetro de entrada, para no recibir un objeto, sino un string.
  async getInfoAfiliado(objetoParametros: ParametrosImprimirAdmisionEntity, uncoEmpresa: string) {
    try {
      const response = await this.requestUrl.getRequest(
        'admisiones/informacion-afiliado',
        [
          objetoParametros.codigoBaseDatos,
          {
            unco_admision: objetoParametros.uncoAdmision,
            unco_admision_empresa: uncoEmpresa
          }
        ]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioSolicitudesSuministros.getInformacionAfiliado() ${e}`);
    }
    return null;
  }

  async getInformacionAdmision(objetoParametros: ParametrosImprimirAdmisionEntity) {
    try {
      const response = await this.requestUrl.getRequest('admision/detalle-admision',
      [
        objetoParametros.codigoBaseDatos,
        {
          uncoAdmision : objetoParametros.uncoAdmision,
          uncoAdmisionEmpresa : objetoParametros.uncoAdmisionEmpresa
        }
      ]);
      return response;
    } catch (e) {
      console.error(`ServicioImprimirAdmisionService.getInformacionAdmision() ${e}`);
    }
  }

  async getInformacionAnticipos(objetoParametros: ParametrosImprimirAdmisionEntity) {
    try {
      const response = await this.requestUrl.getRequest('admision/anticipos',
      [
        objetoParametros.codigoBaseDatos,
        {
          uncoAdmision : objetoParametros.uncoAdmision,
          uncoAdmisionEmpresa : objetoParametros.uncoAdmisionEmpresa
        }
      ]);
      return response;
    } catch (e) {
      console.error(`ServicioImprimirAdmisionService.getInformacionAdmision() ${e}`);
    }
  }

}

export interface ParametrosImprimirAdmisionEntity {
  codigoBaseDatos: string;
  uncoSede: string;
  uncoLogin: string;
  uncoAdmision: string;
  uncoAdmisionEmpresa ?: string;
}

export interface EmpresaAdmision {
  uncoAdmisionEmpresa: number;
  uncoEmpresa: string;
  descripcionEmpresa: string;
}

export interface OcultarDetalle {
  name: string;
  value: boolean;
}

export interface FiltrosImprimirAdmisionEntity {
  codigoBaseDatos: string;
  uncoAdmisionEmpresa: string;
  ocultarDetalle: boolean;
}

export interface EntidadEmpresarial {
  identificacionTributaria: string;
  digitoVerificacion: string;
  descripcion: string;
  direccion: string;
  telefono: string;
  logoUrl: string;
  codigoPrestador: string;
}

export interface InformacionUsuarioEntity {
  nombreUsuario: string;
  codigoBarrasImprime: string;
}

export interface InformacionAfiliadoEntity {
  consecutivoAdmision: string;
  descripcionEmpresa: string;
  descripcionEstadoAdmision: string;
  descripcionEstratoAfiliado: string;
  descripcionSede: string;
  descripcionTipoAfiliado: string;
  direccionAfiliado: string;
  edad: string;
  fechaAdmision: string;
  fechaNacimiento: string;
  nombreAfiliado: string;
  numeroIdentificacionAfiliado: string;
  telefonoAfiliado: string;
  uncoSede: number;
  valorTotalAtencion: string;
  ValorTotalIva: string;
  ValorTotalServicios: string;
  ValorTotalSuministros: string;
}

export interface InformacionDetalleAdmisionEntity {
  codigoProcedimiento: string;
  descripcionProcedimiento: string;
  cantidad: number;
  valorUnitario: number;
  valorPorcentaje: number;
  valorTotal: number;
  descripcionEmpresa: string;
  identificacionEmpresa: string;
  descripcionPuntoAtencion: string;
  identificador: string;
  uncoAdmisionEmpresaPuntoAtencion: number;
  uncoAdmisionEmpresa: number;
  activaEncabezadoPaquete: boolean;
}

export interface InformacionAnticipoAdmisionEntity {
  descripcionEmpresa: string;
  identificacionEmpresa: string;
  formaPago: string;
  valor: number;
  uncoAdmisionEmpresa: number;
}

export interface AgrupacionAdmisionPorEmpresaEntity {
  empresa: string;
  valor: number;
  detalles ?: InformacionDetalleAdmisionEntity[];
  puntosAtencion: AgrupacionAdmisionPorPuntoAtencionEntity[];
}

export interface AgrupacionAdmisionPorPuntoAtencionEntity {
  puntoAtencion: string;
  valor: number;
  detalles ?: InformacionDetalleAdmisionEntity[];
  tipos: AgrupacionAdmisionPorTipoEntity[];
}

export interface AgrupacionAdmisionPorTipoEntity {
  tipo: string;
  descripcion: string;
  valor: number;
  detalles: InformacionDetalleAdmisionEntity[];
}

export interface AgrupacionAnticipoAdmisionEmpresaEntity {
  empresa: string;
  valor: number;
  detalles: InformacionAnticipoAdmisionEntity[];
}

export interface ReporteAdmisionEntity {
  entidad: EntidadEmpresarial;
  empresa: EmpresaAdmision;
  usuario: InformacionUsuarioEntity;
  afiliado: InformacionAfiliadoEntity;
  detalle: number; // 0: esconder, 1: mostrar
  detalleAdmision: InformacionDetalleAdmisionEntity[];
  anticipos: InformacionAnticipoAdmisionEntity[];
}

